import { Global } from '@emotion/react';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import {
  Box,
  GlobalStyles,
  Stack,
  SwipeableDrawer,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import useWindowDimensions from '../hooks/useWindowDimensions';

const SwipeableEdgeDrawer = ({ content, children, title }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const drawerBleeding = open ? 56 : 105;
  const toggleDrawer = newOpen => () => {
    setOpen(newOpen);
  };

  const { height } = useWindowDimensions();

  return (
    <>
      <GlobalStyles
        styles={{
          body: {
            height: `${height}px`,
            minHeight: 'auto',
          },
          main: {
            overflow: 'hidden',
          },
        }}
      />
      <Box data-testid="responsive-summary">
        <Global
          styles={{
            '.MuiDrawer-root > .MuiPaper-root': {
              height: `calc(80% - ${drawerBleeding}px)`,
              overflow: 'visible',
              position: 'absolute',
            },
          }}
        />
        <SwipeableDrawer
          anchor="bottom"
          open={open}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          swipeAreaWidth={drawerBleeding}
          disableSwipeToOpen={false}
          transitionDuration={100}
          hysteresis={0.1}
          ModalProps={{
            keepMounted: true,
          }}
          SwipeAreaProps={{
            'data-testid': 'responsive-swipeArea',
            sx: {
              zIndex: open ? 1199 : 1201,
            },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: -drawerBleeding,
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              visibility: 'visible',
              right: 0,
              left: 0,
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                py: 2,
                borderBottom: '1px solid',
                borderColor: theme.palette.divider,
                height: drawerBleeding,
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
              >
                <Typography color="primary" variant="button">
                  {title}
                </Typography>
                {open ? (
                  <KeyboardArrowDown
                    style={{ color: theme.palette.primary.main }}
                  />
                ) : (
                  <KeyboardArrowUp
                    style={{ color: theme.palette.primary.main }}
                  />
                )}
              </Stack>
            </Box>
          </Box>
          <Box
            sx={{
              px: 2,
              py: 2,
              height: '100%',
              overflow: 'auto',
            }}
          >
            {content}
          </Box>
          {open && (
            <Box
              sx={{
                p: 1,
                borderTop: '1px solid',
                borderColor: theme.palette.divider,
              }}
              data-testid="open-summary-button"
            >
              {children}
            </Box>
          )}
        </SwipeableDrawer>
        {!open && (
          <Box
            sx={{
              p: 1,
              position: 'absolute',
              left: '0',
              bottom: '0',
              width: '100%',
              backgroundColor: theme.palette.background.paper,
              zIndex: 1300,
              borderTop: '1px solid',
              borderColor: theme.palette.divider,
            }}
            data-testid="closed-summary-button"
          >
            {children}
          </Box>
        )}
      </Box>
    </>
  );
};

export default SwipeableEdgeDrawer;
